module.exports = __webpack_public_path__ + "static/media/star-1.addf059f.svg";